import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addFromTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ jobNccClassAddFromTemplateShow: true });
  setTimeout(() => {
    pageComponent.jobNccClassAddFromTemplate.current?.getNccBuildingClassificationTemplateDataSource();
  }, config.setTimeoutMilliSecond);
}

export function addSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
}

export function editSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
}

export function addJobNccClassPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('CostOfWorks', 0);
}

export function deleteJobNccClassRun({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
}

//Building Applies 选择后快速填写数据
export function buildingAppliesOnSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldsValue({ PermittedUse: data.data.PermittedUse, MaxFloorLiveLoad: data.data.MaxFloorLiveLoad });
}
